export default "__VITE_ASSET__48e593b8__"